import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";
const Footer = () => {
  const navigate = useNavigate();
  return (
    <>
      <div
        style={{
          background: "#151515",
          padding: "110px 0px 60px 0px",
        }}
      >
        <Container>
          <Row>
            <Col className="footerOne" style={{ marginLeft: "100px" }}>
              <div style={{ cursor: "pointer" }} onClick={() => {
                navigate("/");
              }}>
                {" "}
                <img src="../images/Group.png"></img>
              </div>
              <div className="address-container" style={{ display: "flex", alignItems: "center" }}>

                <div style={{
                  fontSize: "24px",
                  color: "white",
                  marginTop: "40px",
                }}>
                  Workbond Inc<br />
                  396 N Morrison <br />
                  95126, San Jose CA
                </div>
                <div
                  style={{
                    fontSize: "24px",
                    color: "white",
                    marginTop: "40px", marginLeft: 50
                  }}
                >
                  Bond Media Oy<br />
                  Viipurinkatu 14 A 2 <br />
                  00510, Helsinki Finland
                </div>
              </div>


              <div
                style={{ fontSize: "24px", color: "white", marginTop: "25px" }}
              >
                info@communitybond.io
              </div>
              <div
                style={{ fontSize: "18px", color: "white", marginTop: "90px" }}
              >
                2022 All right Reserved.
              </div>
            </Col>
            <Col className="footerTwoContainer">
              <div>
                <div
                  className="footerTwo"
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    fontSize: "24px",
                    color: "white",
                    marginTop: "20px",
                  }}
                >
                  <div
                    style={{ paddingRight: "100px", cursor: "pointer" }}
                    onClick={() => {
                      navigate("/");
                    }}
                  >
                    Home
                  </div>
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      navigate("/contact");
                    }}
                  >
                    Contact
                  </div>
                </div>
                <div
                  style={{
                    fontSize: "24px",
                    color: "white",
                    marginTop: "20px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    navigate("/story");
                  }}
                >
                  Story
                </div>
              </div>
              <div
                className="footerTwo"
                style={{
                  marginTop: "80px",

                }}
              >
                <div
                  className="footerTwo"
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    <a href=" https://www.facebook.com/startbonding " target="_blank">     <img src="../images/FaceBook.png"></img></a>
                  </div>
                  <div
                    style={{
                      marginLeft: "40px",
                      cursor: "pointer"
                    }}
                  >
                    <a href="https://www.instagram.com/bondcalifornia/" target="_blank">  <img src="../images/Instagram.png"></img></a>
                  </div>
                  <div
                    style={{
                      marginLeft: "40px", cursor: "pointer"
                    }}
                  >
                    <a href="https://www.linkedin.com/company/communitybond/" target="_blank">   <img src="../images/LinkedIn.png"></img></a>
                  </div>
                  <div
                    style={{
                      marginLeft: "40px",
                      cursor: "pointer"
                    }}
                  >
                    <a href="https://www.tiktok.com/@bondcalifornia " target="_blank"> <img src="../images/TicTok.png"></img></a>
                  </div>
                </div>
                <div
                  className="footerTwo"
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >

                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Footer;
